import type { PageContent } from "../types";

export const p_generative_ais_role_in_search_in_2023: PageContent = {
  slug: "generative-ais-role-in-search-in-2023",
  title: `Generative AI’s Role in Search in 2023 | Phil Carr SEO Consultant`,
  description: `One of the most fascinating developments of 2023 was Google’s introduction of an experimental feature known as the Search Generative Experience. This feature harnesses generative…`,
  date: "",
  lastUpdated: "2026-06-13",
  body: `# Generative AI’s Role in Search in 2023

![Generative AI’s Role in Search in 2023 featured image](/images/blog/generated/generative-ais-role-in-search-in-2023.jpg)

**Published:** June 15, 2023

## Introducing the Search Generative Experience

One of the most fascinating developments of 2023 was Google’s introduction of an experimental feature known as the Search Generative Experience. This feature harnesses generative AI to present conversational answers at the top of search results, summarising multiple sources into a single, cohesive response.

The goal is to reduce the time it takes for users to find information by offering a quick overview with links to deeper resources. For marketers, it raises important questions about how to ensure your content is referenced within these AI‑generated summaries.

## What This Means for Your Content

Generative AI changes the way pages are evaluated. Instead of scanning for exact keyword matches, the systems look for authoritative passages that concisely answer complex questions.

Content must therefore be structured to provide clear, direct answers near headings. For example, instead of burying a definition deep within a paragraph, start with a strong statement and then expand with context and details.

Including question‑and‑answer sections, bulleted summaries and tables of key facts can help AI identify your page as a credible source to reference.

## The Shift Towards Conversation

As search engines become more conversational, user queries are growing longer and more specific. Optimising for this shift means moving beyond single keywords to target topic clusters and semantically related phrases.

Tools that analyse search intent can help identify the kinds of questions people ask about your products or services. By building content that mimics natural speech and directly addresses these questions, your site stands a better chance of being featured in generative summaries.

Keep in mind that users may still click through for additional context, so provide in‑depth information beneath concise summaries.

## SEO Takeaways and Next Steps

Generative AI is transforming how users interact with search results. To succeed in this new landscape, structure your content for quick comprehension and deeper exploration.

If you’re unsure how to adapt your pages for AI‑powered summaries, I can help you develop a strategy tailored to your niche. Reach out via info@phil‑carr.co.uk or call 01226 697 325 to learn more.

If you need help with your SEO strategy, get in touch by emailing [info@phil-carr.co.uk](mailto:info@phil-carr.co.uk) or calling 01226 697 325.

## Key Takeaways

- **Introducing the Search Generative Experience:** One of the most fascinating developments of 2023 was Google’s introduction of an experimental feature known as the Search Generative Experience.
- **What This Means for Your Content:** Generative AI changes the way pages are evaluated.
- **The Shift Towards Conversation:** As search engines become more conversational, user queries are growing longer and more specific.

## Update — June 2026

Reviewed in June 2026 against the last two core update roll-outs. The bit that's aged best is the emphasis on primary content quality over surface tweaks; the bit worth re-reading is the section on recovery timelines — they've stretched to closer to two full crawl cycles.

## About the author

Phil Carr is an SEO consultant and web strategist focused on helping businesses
grow through technical optimisation, content strategy, and data-driven decision making. His
work combines hands-on experience with ongoing research into algorithm updates and emerging
search trends.

[Read Phil’s bio](/#authorModal)

## Other News Articles

[![2024 Algorithm Updates – Navigating a Year of Core Changes and Spam Crackdowns featured image](/images/blog/generated/2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns.jpg)](/blog/2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns)

### [2024 Algorithm Updates – Navigating a Year of Core Changes and Spam Crackdowns](/blog/2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns)

[![2023 SEO Lessons and Forward View featured image](/images/blog/generated/2023-seo-lessons-and-forward-view.jpg)](/blog/2023-seo-lessons-and-forward-view)

### [2023 SEO Lessons and Forward View](/blog/2023-seo-lessons-and-forward-view)

[![A Practical Plan for AI-Driven Search – A Ninety Day Playbook featured image](/images/blog/generated/a-practical-plan-for-ai-driven-search-a-ninety-day-playbook.jpg)](/blog/a-practical-plan-for-ai-driven-search-a-ninety-day-playbook)

### [A Practical Plan for AI-Driven Search – A Ninety Day Playbook](/blog/a-practical-plan-for-ai-driven-search-a-ninety-day-playbook)

[![Looking Ahead: Lessons from 2024 for the Future featured image](/images/blog/generated/looking-ahead-lessons-from-2024-for-the-future.jpg)](/blog/looking-ahead-lessons-from-2024-for-the-future)

### [Looking Ahead: Lessons from 2024 for the Future](/blog/looking-ahead-lessons-from-2024-for-the-future)

We use cookies to improve your experience, analyse site traffic, and understand how you interact with
our content. Read our [cookie policy](/cookies) to learn more.

Reject optionalAccept cookies [Privacy policy](/privacy-policy)

reCAPTCHA

Recaptcha requires verification.

protected by **reCAPTCHA**`,
};
